/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAddFieldsDto,
  ApiCreateHubDto,
  ApiSafeExportResponseDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Data<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Create hub
   *
   * @tags User data collector
   * @name UserDataCollectorControllerRequestExport
   * @summary Create hub
   * @request POST:/data
   * @secure
   * @response `201` `boolean`
   */
  userDataCollectorControllerRequestExport = (
    data: ApiCreateHubDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/data`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get data by current hubs
   *
   * @tags User data collector
   * @name UserDataCollectorControllerCurrcurrentExportRequest
   * @summary Get data by current hubs
   * @request GET:/data
   * @secure
   * @response `200` `(ApiSafeExportResponseDto)[]`
   */
  userDataCollectorControllerCurrcurrentExportRequest = (
    params: RequestParams = {},
  ) =>
    this.request<ApiSafeExportResponseDto[], ApiBaseError>({
      path: `/data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Delete user hub
   *
   * @tags User data collector
   * @name UserDataCollectorControllerDeleteUserHub
   * @summary Delete user hub
   * @request DELETE:/data
   * @secure
   * @response `200` `boolean`
   */
  userDataCollectorControllerDeleteUserHub = (params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/data`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Addition of additional data (ip address and awsUserId)
   *
   * @tags User data collector
   * @name UserDataCollectorControllerAddExportAdditionalFields
   * @summary Addition of additional data (ip address and awsUserId)
   * @request POST:/data/additional-fields
   * @secure
   * @response `200` `boolean`
   */
  userDataCollectorControllerAddExportAdditionalFields = (
    data: ApiAddFieldsDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/data/additional-fields`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Notify user that export is done
   *
   * @tags User data collector
   * @name UserDataCollectorControllerNotifyUserThatExportDone
   * @summary Notify user that export is done
   * @request POST:/data/notify
   * @secure
   * @response `200` `boolean`
   */
  userDataCollectorControllerNotifyUserThatExportDone = (
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/data/notify`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
